<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <component-header
          title="Delivery Setup Details"
          :hasSearch="false"
          :hasReload="false"
          :hasCreate="false"
          :hasback="true"
          @back-press="$router.push('/setup/deliverysetup')"
        />
      </b-col>
      <b-col md="12">
        <b-card class="Account-card" height="157">
          <b-row class="m-2">
            <b-col md="3">
              <b-row>
                <h4>State :</h4>
                <h5 class="ml-1 text-muted">{{ inputObject.state }}</h5>
              </b-row>
            </b-col>
            <b-col md="3">
              <b-row>
                <h4>City :</h4>
                <h5 class="ml-1 text-muted">{{ inputObject.city }}</h5>
              </b-row>
            </b-col>
            <b-col md="3">
              <b-row>
                <h4>Area :</h4>
                <h4 class="ml-1 text-muted">{{ inputObject.areacode }}</h4>
              </b-row>
            </b-col>
            <b-col md="3">
              <b-row>
                <h4>Transport Mode :</h4>
                <h4 class="ml-1 text-muted">
                  {{ inputObject.transportMode }}
                </h4>
              </b-row>
            </b-col>
            <!-- <b-col md="3">
              <b-row>
                <h4>Start Date :</h4>
                <h4 class="ml-1  text-muted">{{ inputObject.startDate }}</h4>
              </b-row>
            </b-col> -->
          </b-row>
          <b-row class="m-2 p-0">
            <b-col md="3">
              <b-row>
                <h4>Start Date :</h4>
                <h4 class="ml-1 text-muted">{{ inputObject.startDate }}</h4>
              </b-row>
            </b-col>
            <b-col md="3">
              <b-row>
                <h4>End Date :</h4>
                <h4 class="ml-1 text-muted">{{ inputObject.endDate }}</h4>
              </b-row>
            </b-col>
            <b-col md="3">
              <b-row>
                <h4>Category :</h4>
                <h4 class="ml-1 text-muted">{{ inputObject.category }}</h4>
              </b-row>
            </b-col>
            <b-col md="3">
              <b-row>
                <h4>Rank :</h4>
                <h4 class="ml-1 text-muted">{{ inputObject.rank }}</h4>
              </b-row>
            </b-col>
            <b-col md="3">
              <b-row>
                <h4>Default charge :</h4>
                <h4 class="ml-1 text-muted">{{ inputObject.dwf }}</h4>
              </b-row>
            </b-col>

            <b-col md="3">
              <b-row>
                <h4>Delivery Owner :</h4>
                <h4 class="ml-1 text-muted">
                  {{ inputObject.deliveryOwner }}
                </h4>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <div>
      <b-row>
        <b-col md="8">
          <h4>Distance Tier</h4>
        </b-col>
      </b-row>
      <div v-for="(t, idx) in inputObject.distanceTier" :key="idx">
        <v-card class="mt-1 mb-3">
          <b-row style="background-color: var(--secondary)" class="m-0">
            <b-col md="6">
              <h4 class="text-white">
                Distance Tier Name : {{ inputObject.distanceTier[idx].tier }}
              </h4>
            </b-col>
            <b-col md="2"></b-col>
            <b-col md="2">
              <h4 class="text-white">
                Start Range(KM) : {{ inputObject.distanceTier[idx].from }}
              </h4>
            </b-col>
            <b-col md="2">
              <h4 class="text-white">
                End Range(KM) : {{ inputObject.distanceTier[idx].to }}
              </h4>
            </b-col>
          </b-row>
          <b-row
            v-for="(p, wIdx) in inputObject.distanceTier[idx].weight"
            :key="wIdx"
            class="p-0 m-2"
          >
            <b-col>
              <b-row>
                <label class="mr-1"><b>Start Range (KG) : </b></label>
                {{ inputObject.distanceTier[idx].weight[wIdx].from }}
              </b-row>
            </b-col>
            <b-col>
              <b-row>
                <label class="mr-1"><b>End Range (KG) : </b></label>

                {{ inputObject.distanceTier[idx].weight[wIdx].to }}
              </b-row>
            </b-col>

            <b-col>
              <b-row>
                <label class="mr-1"><b>Time : </b></label>
                {{
                  inputObject.distanceTier[idx].weight[wIdx].etd
                    ? inputObject.distanceTier[idx].weight[wIdx].etd.time
                    : ""
                }}
                {{
                  inputObject.distanceTier[idx].weight[wIdx].etd
                    ? inputObject.distanceTier[idx].weight[wIdx].etd.uom
                    : ""
                }}
              </b-row>
            </b-col>
            <b-col>
              <b-row>
                <label class="mr-1"><b>Customer Cost : </b></label>

                {{ inputObject.distanceTier[idx].weight[wIdx].customerFee }}
              </b-row>
            </b-col>

            <b-col>
              <b-row>
                <label class="mr-1"><b>Delivery Cost : </b></label>
                {{
                  inputObject.distanceTier[idx].weight[wIdx].deliveryAgentFee
                }}
              </b-row>
            </b-col>
          </b-row>
        </v-card>
      </div>
    </div>
  </div>
</template>
<script>
import cInput from "@/components/Common/CustomInput";
import ebButton from "@/components/FormElements/Button";
import currentUser from "@/mixins/currentUser";
import ComponentHeader from "@/components/componentNewHeader";
export default {
  mixins: [currentUser],
  components: {
    cInput,
    ebButton,
    ComponentHeader,
  },
  data() {
    return {
      inputObject: {
        city: "",
        state: "",
        category: "",
        transportMode: "",
        startDate: "",
        endDate: "",
        rank: "",
        areacode: "",
        dwf: "",
        deliveryOwner: "",
        distanceTier: [
          {
            tier: "",
            from: "",
            to: "",
            isRemovable: false,
            weight: [
              {
                from: "",
                to: "",
                customerFee: "",
                deliveryAgentFee: "",
                isRemovable: false,
              },
            ],
          },
        ],
      },
      details: {},
    };
  },
  // props: {
  //   details: {
  //     type: Object,
  //     required: true,
  //   },
  // },
  computed: {},
  async mounted() {
    this.details = { ...this.$route.params.data };
    (this.inputObject.city =
      this.details.city == "*" ? "All cities" : this.details.city),
      (this.inputObject.state =
        this.details.state == "*" ? "All states" : this.details.state),
      (this.inputObject.transportMode = this.details.transportMode),
      //(this.inputObject.category = this.details.category),
      (this.inputObject.startDate = this.details.StartDate),
      (this.inputObject.endDate = this.details.EndDate),
      (this.inputObject.rank = this.details.rank),
      (this.inputObject.dwf = this.details.dwf);
    (this.inputObject.areacode = this.details.areaCode),
      (this.inputObject.deliveryOwner = this.details.deliveryOwner.name),
      (this.inputObject.distanceTier = this.details.distance);

    if (this.$userRole == "Tenant") {
      if (!this.$store.getters["catalog/GetTenantCatalogTree"].length > 0) {
        await this.$store.dispatch("catalog/fetchTenantCatalogTree");
      } else {
      }
    } else if (this.$userRole == "Partner") {
      if (!this.$store.getters["catalog/GetPartnerCatalogTree"].length > 0) {
        await this.$store.dispatch("catalog/fetchPartnerCatalogTree");
      } else {
      }
    }

    if (this.$userRole == "Tenant") {
      if (this.$store.getters["catalog/GetTenantCatalogTree"].length > 0) {
        let filtredList = this.$store.getters[
          "catalog/GetTenantCatalogTree"
        ].filter((obj) => {
          return this.details.category_id == obj._id;
        });

        if (filtredList.length > 0) {
          this.inputObject.category = filtredList[0].name
            ? filtredList[0].name
            : "*";
        } else {
          this.inputObject.category = "All categories";
        }
      }
    } else if (this.$userRole == "Partner") {
      if (this.$store.getters["catalog/GetPartnerCatalogTree"].length > 0) {
        let filtredList = this.$store.getters[
          "catalog/GetPartnerCatalogTree"
        ].filter((obj) => {
          return this.details.category_id == obj._id;
        });

        if (filtredList.length > 0) {
          this.inputObject.category = filtredList[0].name
            ? filtredList[0].name
            : "*";
        } else {
          this.inputObject.category = "All categories";
        }
      }
    }
  },
  methods: {},
};
</script>

<style scoped>
p {
  font-size: 13px;
}
.Account-card {
  background-color: #ffffff;
  padding-top: 0px;
  border-radius: 15px;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}
th,
td {
  padding: 8px;
  color: #000000;
  font-weight: bold;
}
th {
  width: 46%;
  color: #8f8f8f;
}
</style>
